import { apiClient } from '../../../app/api/apiClient';
import type { DashboardOverview } from '../types/dashboard.types';

export async function getDashboardOverview(): Promise<DashboardOverview> {
  const response = await apiClient.get('/api/super-admin/dashboard/overview');
  return (response.data as { dashboard: DashboardOverview }).dashboard;
}
